export const AI_LABEL_PREFIX = '|:'
